import React, { useState } from 'react'

import { IconButton } from '@material-ui/core'
import axios from 'axios'
import SectionsEdit from './SectionsEdit'
import SectionsDelete from './SectionsDelete'
import { Delete, DeleteOutline, Edit } from '@material-ui/icons'

import iziToast from 'izitoast'
import { useStoreon } from 'storeon/react'

interface ActionButtonsProps {
	_id: string
	createdBy: string
	onDeleteSuccess?: () => void
	onEditSuccess?: () => void
	rowData: any
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
	_id,
	createdBy,
	rowData,
	onDeleteSuccess,
	onEditSuccess
}) => {
	const [deleting, setDeleting] = useState(false)
	const [editOpen, setEditOpen] = useState(false)
	const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false)
	const [deleteError, setDeleteError] = useState('')
	const { token } = useStoreon('token')

	const handleDelete = async () => {
		try {
			setDeleting(true)
			setDeleteError('')

			const response = await axios.delete(
				`${process.env.REACT_APP_API_URL}/api/v1/custom/deleteSection`,
				{
					data: {
						sectionId: _id,
						userId: createdBy
					},
					headers: {
						Authorization: ` ${token}`
					}
				}
			)

			if (response.status === 200) {
				iziToast.success({
					message: 'Section deleted successfully!'
				})
				if (onDeleteSuccess) onDeleteSuccess()
			}
		} catch (error) {
			console.error('Error deleting section:', error)

			const errorMsg = axios.isAxiosError(error)
				? error.response?.data?.message
				: 'An unknown error occurred'

			setDeleteError(errorMsg)

			iziToast.error({
				message: errorMsg
			})
		} finally {
			setDeleting(false)
			setConfirmDeleteOpen(false)
		}
	}

	return (
		<>
			<div
				style={{
					display: 'flex',
					gap: '8px',
					justifyContent: 'center',
					alignItems: 'center'
				}}
			>
				<IconButton
					onClick={() => setEditOpen(true)}
					// sx={{ '&:hover': { color: '#33cc33' } }}
					sx={{ color: '#7D6EF1' }}
					disabled={deleting}
					aria-label="edit"
				>
					<Edit />
				</IconButton>
				<IconButton
					onClick={() => setConfirmDeleteOpen(true)}
					sx={{ color: 'red' }}
					disabled={deleting}
					aria-label="delete"
				>
					<DeleteOutline />
				</IconButton>
			</div>

			{/* {deleteError && <div style={{ color: 'red', fontSize: '12px' }}>{deleteError}</div>} */}

			<SectionsEdit
				open={editOpen}
				setOpen={setEditOpen}
				rowData={rowData}
				onSuccess={onEditSuccess}
			/>

			<SectionsDelete
				open={confirmDeleteOpen}
				onClose={() => setConfirmDeleteOpen(false)}
				onConfirm={handleDelete}
			/>
		</>
	)
}

export default ActionButtons
